import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Logout = () => {
	const { logout  } = useAuth();
	const navigate = useNavigate();
	useEffect(() => {
		const checkAuth = async () => {
		  await logout(); // This will auto logout if invalid		  
		};
		checkAuth();
	}, [logout]);	
	
};
export default Logout;